var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:"back-prompt",attrs:{"to":"/"}},[_vm._v("back"),_c('span',{staticClass:"diamond"})])}
var staticRenderFns = []

export { render, staticRenderFns }